// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Type_UserAgent = require("../type/Type_UserAgent.bs.js");

function make(param) {
  var match = React.useState(function () {
        
      });
  var setState = match[1];
  React.useEffect((function () {
          Curry._1(setState, (function (param) {
                  return {
                          userAgent: Type_UserAgent.userAgent,
                          platform: Type_UserAgent.platform
                        };
                }));
        }), []);
  return match[0];
}

exports.make = make;
/* react Not a pure module */
